export default "__VITE_ASSET__CG1wBRs2__"